const styles = theme => ({
  table: {
    border: '1px solid #e0e0e0'
  },
  tableHeader: {
    textTransform: 'uppercase',
    color: '#737273'
  },
  tableCell: {
    color: '#4a4a4a',
  },
  shrink: {
    wordBreak: 'break-word',
  },
  paginationBox: {
    flexShrink: 0,
    marginLeft: theme.spacing(2),
  },
  pageInputWrapper: {
    margin: theme.spacing(0, 0.5),
    verticalAlign: 'middle'
  },
  pageInput: {
    width: 30,
    textAlign: 'center',
    padding: theme.spacing(0.5, 0)
  },
  highlight: {
    backgroundColor: theme.colorTokens.background,
  },
  notFound: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
})

export default styles;